<template>
  <v-container grid-list-md>
    <v-card>
      <v-card-title>
        Company Properties
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          outlined
          solo
          append-icon="fas fa-search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :no-data-text="noData"
          :loading="isLoading"
          :headers="headers"
          :items="Properties"
          :search="search"
        >
          <template v-slot:[`item.more`]="{ item }">
            <base-row-layout>
              <!-- Edite ICON -->
              <div>
                <v-btn icon color="primary">
                  <v-icon class="mr-2" @click="EditeExpense(item)">
                    fas fa-pencil-alt
                  </v-icon>
                </v-btn>
              </div>
              <!-- Transaction ICON -->
              <div>
                <v-btn icon color="primary">
                  <ExpenseTran
                    :BaseURL="BaseURL"
                    :Title="item.PropertyName"
                    :TranInfo="item"
                    :queryKey="{ _id: item._id, type: item.PropertyType }"
                  >
                  </ExpenseTran>
                </v-btn>
              </div>
              <!-- Show Balance Icon -->
              <div>
                <ShowBalance
                  :key="item._id + 'Balance'"
                  :ReqURL="BaseURL + '/balance'"
                  :Title="item.PropertyName"
                  :query="{ _id: item._id, type: item.PropertyType }"
                >
                </ShowBalance>
              </div>
              <!-- More Option -->
              <div>
                <MoreOption
                  :BaseURL="BaseURL"
                  :key="item._id + 'MoreOption'"
                  :expenseInfo="item"
                ></MoreOption>
              </div>
            </base-row-layout>
          </template>
        </v-data-table>
        <!-- {{ isEditing }} -->
      </v-card-text>
      <v-card-actions>
        <!-- <v-speed-dial bottom left absolute direction="right" v-model="fab">
          <template v-slot:activator> </template>
        </v-speed-dial> -->
        <new-property
          :loadFunction="loadProperties"
          :OnEdite="OnEdite"
          :isEditing="isEditing"
          @input="isEditing = $event"
        >
        </new-property>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
export default {
  // components: { Custtransaction },
  components: {
    NewProperty: () => import("@/components/Branches/Equipments/newProperty"),
    MoreOption: () => import("@/components/Branches/Equipments/MoreOption"),
    ShowBalance: () => import("@/components/util/showBalance.vue"),
    ExpenseTran: () => import("@/components/Branches/Equipments/propertyTran"),
  },
  data() {
    return {
      noData: "No Property is availble",
      BaseURL: "/qarash/investment",
      fab: false,
      isLoading: true,
      isEditing: false,
      OnEdite: {},
      Properties: [],
      search: "",
      headers: [
        {
          text: "Property",
          align: "left",
          value: "PropertyName",
        },
        { text: "Description", value: "Info" },
        { text: "Type", value: "type" },

        // { text: "Edite", value: "edite", align: "center", sortable: false },
        // { text: "Balance", value: "blc", align: "center", sortable: false },
        // { text: "Tran", value: "tran", align: "center", sortable: false },
        {
          text: "More",
          value: "more",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    // ...mapGetters(["Properties"]),
  },
  methods: {
    EditeExpense(E_Supp) {
      // console.log(E_Supp);
      this.isEditing = true;
      this.OnEdite = E_Supp;
    },
    GetReq(url, query = {}) {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    loadProperties() {
      this.GetReq(this.BaseURL)
        .then(result => {
          // console.log(result);
          this.Properties = result.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    // HeaderIntialize() {
    //   return
    // }
  },

  created() {
    // this.headers = this.HeaderIntialize();

    this.loadProperties();
  },
};
</script>
